import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export const getMediaFlagByClass = (mediaClass) => {
  if (mediaClass === "Audio") return "has_audio";
  if (mediaClass === "Texto") return "has_text";
  if (mediaClass === "Video") return "has_video";
  return null;
};

export const normalizeIds = (value) => {
  if (!Array.isArray(value)) return [];
  return value
    .map((item) => (typeof item === "object" && item != null ? item.id : item))
    .map((item) => Number(item))
    .filter((item) => Number.isInteger(item) && item > 0);
};

export const getEligibleTypePlanIds = (typePlans, categoryMediaId, mediaClass) => {
  const mediaFlag = getMediaFlagByClass(mediaClass);
  const categoryId = Number(categoryMediaId);

  if (!mediaFlag || !Number.isInteger(categoryId)) return [];

  return typePlans
    .filter((plan) => {
      const hasMediaClass = Boolean(plan?.[mediaFlag]);
      const categories = normalizeIds(plan?.categories_media);
      return hasMediaClass && categories.includes(categoryId);
    })
    .map((plan) => Number(plan.id))
    .filter((id) => Number.isInteger(id) && id > 0);
};

export const withPlanAvailability = (typePlans, mediaClass, categoryMediaId) => {
  const mediaFlag = getMediaFlagByClass(mediaClass);
  const categoryId = Number(categoryMediaId);
  if (!Array.isArray(typePlans)) return [];

  return typePlans.map((plan) => {
    const supportsMediaClass = mediaFlag ? Boolean(plan?.[mediaFlag]) : true;
    const categories = normalizeIds(plan?.categories_media);
    const supportsCategory = Number.isInteger(categoryId) ? categories.includes(categoryId) : true;
    return {
      ...plan,
      disabled: !supportsMediaClass || !supportsCategory,
    };
  });
};

const SupportIcon = ({ enabled }) =>
  enabled ? (
    <CheckCircleIcon fontSize="inherit" color="success" />
  ) : (
    <CancelIcon fontSize="inherit" color="disabled" />
  );

const SupportBadge = ({ label, enabled }) => (
  <Stack direction="row" spacing={0.5} alignItems="center" sx={{ fontSize: 12 }}>
    <SupportIcon enabled={enabled} />
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
  </Stack>
);

export const renderTypePlanItem = (plan) => (
  <Box>
    <Typography variant="body2">{plan?.name}</Typography>
    <Stack direction="row" spacing={1.25} sx={{ mt: 0.25 }}>
      <SupportBadge label="Audio" enabled={Boolean(plan?.has_audio)} />
      <SupportBadge label="Texto" enabled={Boolean(plan?.has_text)} />
      <SupportBadge label="Video" enabled={Boolean(plan?.has_video)} />
    </Stack>
  </Box>
);

export const renderTypePlanDialogExtra = ({ data }) => {
  const disabledCount = Array.isArray(data) ? data.filter((plan) => plan?.disabled).length : 0;
  if (disabledCount === 0) return null;

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      Só estão disponíveis os planos que possuem a categoria de mídia selecionada e suportam a classe de mídia.
    </Alert>
  );
};
